module.exports = __webpack_public_path__ + "img/place-phone-inscreen.7c4605bd.png";